import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import './App.css';
import Antigravity from './components/Antigravity';
import DecryptedText from './components/DecryptedText'; 
import BlurText from './components/BlurText';
function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [direction, setDirection] = useState(0);
  const [articles, setArticles] = useState([]);
  const [projects, setProjects] = useState([]);

  const pagesOrder = ['home', 'articles', 'projects', 'articleDetail'];

  const handlePageChange = (newPage) => {
    const oldIndex = pagesOrder.indexOf(currentPage);
    const newIndex = pagesOrder.indexOf(newPage);
    if (oldIndex !== -1 && newIndex !== -1) {
      setDirection(newIndex > oldIndex ? 1 : -1);
    } else {
      setDirection(0);
    }
    setCurrentPage(newPage);
  };

  const pageVariants = {
    initial: (direction) => ({
      x: direction > 0 ? 300 : -300,
      opacity: 0,
    }),
    animate: {
      x: 0,
      opacity: 1,
      transition: {
        x: { type: 'spring', stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 }
      }
    },
    exit: (direction) => ({
      x: direction < 0 ? 300 : -300,
      opacity: 0,
      transition: {
        x: { type: 'spring', stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 }
      }
    })
  };

  // Load lists on demand
  useEffect(() => {
    if (currentPage === 'articles' && articles.length === 0) {
      loadArticles();
    }
    if (currentPage === 'projects' && projects.length === 0) {
      loadProjects();
    }
  }, [currentPage, articles.length, projects.length]);

  const loadArticles = async () => {
    try {
      const res = await fetch('/articles.json');
      const data = await res.json();
      setArticles(Array.isArray(data.articles) ? data.articles : []);
    } catch (e) {
      console.error('Failed to load articles', e);
    }
  };

  const loadProjects = async () => {
    try {
      const res = await fetch('/projects.json');
      const data = await res.json();
      setProjects(Array.isArray(data.projects) ? data.projects : []);
    } catch (e) {
      console.error('Failed to load projects', e);
    }
  };

  const openArticle = async (article) => {
    if (article.type === 'external' && article.url) {
      window.open(article.url, '_blank', 'noopener');
      return;
    }

  };


  const renderContent = () => {
    return (
      <AnimatePresence mode="wait" custom={direction}>
        <motion.div
          key={currentPage}
          custom={direction}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          style={{ width: '100%' }}
        >
          {(() => {
            switch (currentPage) {
      case 'home':
        return (
          <div className="content">
            <div  style={{boxShadow: '0 12px 24px rgba(242, 181, 196, 0.3)'}} className="hero">
              <img src="profileimage.jpg" alt="Profile" className="profile-image" />
              <div>
                <BlurText style={{ fontSize: '2.4rem' }} text="Tin Kin" animateOn='both'/>
                <p>探索科技与人文的交汇点</p>
                <div className="social-links">
                  <a href="https://github.com/tinymindkin" target="_blank" rel="noreferrer" aria-label="GitHub" title="GitHub">
                    <svg viewBox="0 0 16 16" width="24" height="24" fill="currentColor" aria-hidden="true">
                      <path d="M8 0C3.58 0 0 3.58 0 8a8 8 0 0 0 5.47 7.59c.4.07.55-.17.55-.38v-1.33c-2.23.48-2.7-1.07-2.7-1.07-.36-.93-.88-1.18-.88-1.18-.72-.49.05-.48.05-.48.8.06 1.22.83 1.22.83.7 1.2 1.84.85 2.29.65.07-.5.27-.85.49-1.04-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.58.82-2.14-.08-.2-.36-1.01.08-2.11 0 0 .67-.21 2.2.82.63-.18 1.3-.27 1.97-.27.67 0 1.34.09 1.97.27 1.53-1.03 2.2-.82 2.2-.82.44 1.1.16 1.91.08 2.11.51.56.82 1.27.82 2.14 0 3.07-1.87 3.75-3.65 3.95.28.24.53.73.53 1.48v2.2c0 .21.15.45.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8z"/>
                    </svg>
                  </a>
                  <a href="https://x.com/yin_yon54525" target="_blank" rel="noreferrer" aria-label="X" title="X">
                    <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true">
                      <path d="M18.244 2H21.5l-7.59 8.686L23 22h-6.828l-5.35-6.446L4.64 22H1.38l8.12-9.297L2 2h6.91l4.827 5.878L18.244 2zm-1.197 18.286h1.984L7.046 3.61H4.94l12.107 16.676z"/>
                    </svg>
                  </a>
                  <a href="https://www.xiaohongshu.com/user/profile/6107f5240000000001007d4a" target="_blank" rel="noreferrer" aria-label="Xiaohongshu" title="Xiaohongshu">
                    <svg viewBox="0 0 1024 1024" width="24" height="24" fill="currentColor" aria-hidden="true">
                      <path d="M512 2.27555555a509.72444445 509.72444445 0 1 0 0 1019.4488889A509.72444445 509.72444445 0 0 0 512 2.27555555z" fill="#FF0035"></path>
                      <path d="M651.37322667 388.93795555c3.64088889 0 5.53415111 0 5.53415111 5.6069689v46.38492444c0 3.64088889-1.82044445 5.53415111-5.53415111 5.53415111h-25.99594667c-5.53415111 0-7.42741333 1.82044445-7.42741333 7.42741333v161.29137778c0 3.71370667 1.89326222 5.60696889 5.60696888 5.60696889h46.38492445c5.53415111 0 7.35459555 1.82044445 7.35459555 7.42741333v44.41884445c0 5.60696889-1.82044445 7.50023111-7.35459555 7.50023111-29.70965333-1.89326222-61.16693333-1.89326222-92.76984889-1.89326222H482.58161778c-5.53415111 0-7.35459555 0-3.64088889-5.53415112 7.35459555-14.85482667 14.78200889-31.53009778 24.02986666-46.38492444 1.89326222-3.64088889 3.71370667-5.53415111 9.32067556-5.53415111h46.38492444c4.36906667 0 5.31569778-1.16508445 5.46133334-4.51470222V451.99815111c0-5.53415111-1.82044445-7.35459555-7.28177778-5.53415111h-25.99594666c-5.60696889 0-7.42741333-1.82044445-7.42741334-5.53415111v-44.56448c0-5.53415111 1.82044445-7.35459555 7.42741334-7.35459556h120.51342222zM391.77784889 617.14887111c12.96156445 5.53415111 27.81639111 3.64088889 42.5984 3.64088889h37.13706666c3.64088889 0 5.53415111 1.89326222 3.6408889 5.60696889-9.24785778 16.74808889-16.67527111 33.42336-25.9231289 50.09863111-1.82044445 3.64088889-3.64088889 3.64088889-7.42741333 3.64088889-9.24785778-1.82044445-20.38897778-1.82044445-35.24380444-1.82044444-11.06830222 0-27.81639111 1.89326222-40.77795556-1.82044445-5.53415111-1.89326222-7.42741333-3.71370667-3.64088889-7.42741333 9.17504-16.74808889 16.60245333-31.53009778 24.02986667-48.20536889 1.89326222-1.89326222 1.89326222-5.60696889 5.60696889-3.71370667z m393.07036444-244.81336889c3.71370667 0 5.60696889 1.89326222 5.60696889 5.60696889 0 12.96156445 0 12.96156445 12.96156445 12.96156444 16.74808889 0 31.53009778 3.71370667 44.49166222 11.14112 18.56853333 11.14112 25.99594667 29.63683555 25.99594666 50.02581334v37.13706666c0 5.53415111 1.82044445 7.42741333 7.42741334 7.42741334 20.38897778 0 37.06424889 5.53415111 50.02581333 22.20942222a55.55996445 55.55996445 0 0 1 11.14112 33.42336V626.32391111c0 27.81639111-16.74808889 48.20536889-44.49166222 51.91907556a75.73048889 75.73048889 0 0 1-35.24380445-1.82044445 48.05973333 48.05973333 0 0 1-33.35054222-42.67121777c0-5.53415111 1.82044445-3.64088889 5.53415112-3.6408889h46.38492444c5.53415111 0 7.42741333-1.89326222 7.42741333-7.5002311v-48.2053689c0-12.96156445-7.42741333-20.38897778-20.38897777-20.38897777h-70.4876089c-3.71370667 0-5.60696889 1.89326222-5.60696888 5.53415111 1.89326222 18.56853333 1.89326222 37.13706667 1.89326222 57.52604444v55.63278222c0 5.53415111-1.89326222 7.42741333-7.42741334 7.42741334h-44.49166222c-5.60696889 0-7.42741333-1.89326222-7.42741333-7.42741334V561.44327111c0-5.53415111-1.89326222-7.42741333-7.42741333-7.42741333h-42.67121778c-5.53415111 0-7.42741333 0-7.42741334-5.53415111v-46.38492445c0-5.53415111 1.89326222-5.53415111 7.42741334-5.53415111h44.49166222c5.60696889 0 7.42741333-1.89326222 5.60696889-7.42741333v-35.24380445c0-5.60696889-1.89326222-5.60696889-7.42741333-5.60696888h-25.99594667c-3.64088889 0-5.53415111 0-5.53415111-5.53415112v-46.38492444c0-3.64088889 1.89326222-5.53415111 5.53415111-5.53415111h25.99594667c3.64088889 0 5.53415111-1.82044445 5.53415111-5.53415111 0-11.35957333 0-12.81592889 9.97603555-12.96156445h41.94304z m-543.29344-5.53415111c5.53415111 0 7.42741333 1.82044445 7.42741334 7.42741334-1.45635555 34.73408-1.74762667 67.42926222-1.82044445 98.81372444V626.32391111a52.35598222 52.35598222 0 0 1-7.50023111 27.81639111c-9.24785778 18.56853333-25.92312889 24.10268445-46.31210666 22.28224a41.72458667 41.72458667 0 0 1-38.95751112-31.53009777c-5.60696889-18.56853333-5.60696889-16.74808889 12.96156445-18.56853334 7.42741333 0 16.74808889 3.71370667 22.28224-1.82044444 3.64088889-3.71370667 1.82044445-12.96156445 1.82044444-20.38897778V374.15594667c0-5.60696889 1.89326222-7.42741333 7.42741333-7.42741334h42.67121778zM148.78492445 451.99815111c-3.64088889 40.77795555-5.53415111 81.55591111-11.06830223 122.40668444a160.92728889 160.92728889 0 0 1-29.70965333 74.20131556c1.89326222 0 0 1.82044445 0 3.64088889-11.14112-20.38897778-20.38897778-40.77795555-31.53009778-61.16693333-1.82044445-1.82044445-1.82044445-3.64088889 0-5.53415112 7.42741333-16.74808889 7.42741333-33.35054222 7.42741334-51.91907555l5.60696888-81.55591111c0-3.78652445 1.82044445-5.60696889 5.53415112-5.60696889h48.20536888c3.71370667 0 5.53415111 0 5.53415112 5.53415111zM337.96551111 446.464c5.53415111 0 5.53415111 1.82044445 7.42741334 7.42741333 1.82044445 37.13706667 5.53415111 74.20131555 9.24785777 111.26556445 0 3.64088889 0 9.24785778 1.89326223 12.96156444 3.64088889 7.42741333 1.82044445 14.85482667-1.89326223 22.28224-7.42741333 14.78200889-14.78200889 31.53009778-22.20942222 46.31210667-1.89326222 5.60696889-3.71370667 5.60696889-7.42741333 0-12.96156445-20.38897778-20.38897778-40.77795555-25.99594667-64.80782222C293.54666667 559.47719111 293.54666667 535.37450667 291.58058667 513.16508445c-1.82044445-20.38897778-3.64088889-38.95751111-5.53415112-59.3464889 0-5.60696889 0-7.42741333 7.42741334-7.42741333 7.42741333 1.82044445 14.85482667 0 22.20942222 0h22.28224z m144.61610667-74.20131555c5.60696889 0 5.60696889 1.89326222 3.71370667 5.60696888l-33.35054223 66.77390222c-1.82044445 1.82044445-1.82044445 3.64088889-3.71370667 7.35459556-1.82044445 3.71370667 0 5.60696889 3.71370667 7.42741334 3.64088889 1.89326222 3.64088889-1.82044445 5.53415111-3.6408889 1.89326222-3.78652445 3.71370667-5.60696889 9.32067556-5.60696888h44.41884444c5.60696889 0 5.60696889 1.82044445 3.78652445 5.53415111-14.85482667 27.81639111-27.81639111 57.52604445-42.67121778 85.34243555-5.53415111 11.14112-3.64088889 14.85482667 9.24785778 14.85482667 3.71370667-1.89326222 11.14112-1.89326222 18.56853333-1.89326222-7.42741333 12.96156445-12.96156445 25.99594667-18.56853333 38.95751111-3.64088889 9.24785778-9.24785778 11.14112-16.67527111 11.14112h-42.5984c-3.71370667 0-7.42741333 0-11.14112-1.89326222-13.03438222-3.64088889-16.74808889-12.96156445-13.03438222-25.92312889 7.42741333-20.38897778 18.56853333-38.95751111 27.8163911-59.34648889 1.89326222-3.71370667 3.71370667-5.60696889 5.6069689-11.14112h-37.13706667c-14.78200889-3.71370667-20.38897778-12.96156445-14.78200889-27.81639111 5.53415111-16.74808889 14.85482667-33.35054222 22.20942222-48.20536889 9.32067555-16.74808889 16.74808889-35.24380445 25.99594667-51.91907556 1.82044445-3.71370667 3.64088889-5.60696889 9.24785777-5.60696888h44.49166223z m315.30097777 74.20131555c-3.71370667 0-5.60696889 1.82044445-5.60696888 5.53415111v38.95751111c0 3.71370667 1.89326222 5.60696889 5.60696888 5.60696889h20.38897778c3.64088889 0 5.53415111-1.89326222 5.53415112-5.60696889v-30.58346667c-0.21845333-13.90819555-2.76707555-13.90819555-25.9231289-13.90819555z m126.04757334-57.52604445c13.03438222 1.89326222 24.10268445 14.85482667 24.10268444 29.70965334s-11.06830222 25.99594667-25.92312888 27.81639111h-14.85482667c-18.49571555 0-18.49571555 0-18.49571556-18.56853333 0-5.53415111 0-12.96156445 1.82044445-18.49571556 3.71370667-14.85482667 16.74808889-22.28224 33.35054222-20.38897778z" fill="#FFFFFF"></path>
                    </svg>
                  </a>
                </div>
                <div className="contact">
                  <div>📱 <a href="tel:13310699735">+86 133 1069 9735</a></div>
                  <div>📧 <a href="mailto:tinkinzhang@gmail.com">tinkinzhang@gmail.com</a></div>
                </div>
              </div>
            </div>
            <div style={{ marginTop: '6rem', textAlign: 'center', fontFamily: "'Fira Code', monospace" }}>
              <DecryptedText text="> Welcome to Tin Kin's Blog" style={{ fontSize: '3rem', fontWeight: 'bold' ,color: '#06d313ff'}} animateOn="view" loop={true} />
            </div>
          </div>
        );
      case 'articles':
        return (
          <div className="content">
            <h2 className="section-title articles-title">
              📚 技术文章库
            </h2>
            <div className="article-list">
              {articles.map((a, idx) => (
                <article key={idx} className="article-item">
                  <div className="article-head">
                    <h3>{a.title || a.slug}</h3>
                    {a.type === 'external' && <span className="tag external">🔗 外链</span>}
                  </div>
                  <div className="article-actions">
                    <button onClick={() => openArticle(a)}>
                      {a.type === 'external' ? '🔗 打开链接' : '👁️ 阅读全文' }
                    </button>
                  </div>
                </article>
              ))}
              {articles.length === 0 && (
                <div style={{ textAlign: 'center', padding: '3rem' }}>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '1.2rem' }}>
                    📭 文章正在整理中，敬请期待...
                  </p>
                </div>
              )}
            </div>
          </div>
        );
      case 'projects':
        return (
          <div className="content">
            <h2 className="section-title projects-title">
              🚀 创新项目集
            </h2>
            <div className="projects-grid">
              {projects.map((p, idx) => (
                <div className="project-card" key={idx}>
                  <h3>{p.name}</h3>
                  <p>{p.description}</p>
                  {p.url && (
                    <a className="btn" href={p.url} target="_blank" rel="noreferrer">
                      🌐 访问项目
                    </a>
                  )}
                </div>
              ))}
              {projects.length === 0 && (
                <div style={{ textAlign: 'center', padding: '3rem' }}>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '1.2rem' }}>
                    🚧 wating...
                  </p>
                </div>
              )}
            </div>
          </div>
        );
      default:
        return <div>Page not found</div>;
    }
          })()}
        </motion.div>
      </AnimatePresence>
    );
  };

  return (
    <div className="App">
      <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1 }}>
  <Antigravity
    count={300}
    magnetRadius={6}
    ringRadius={10}
    waveSpeed={0.8}
    waveAmplitude={1}
    particleSize={1.5}
    lerpSpeed={1.0}
    color="#5227FF"
    autoAnimate
    particleVariance={1}
    rotationSpeed={0}
    depthFactor={1}
    pulseSpeed={3}
    particleShape="capsule"
    fieldStrength={10}
/>
</div>

      <header className="App-header">
        <nav>
          <ul>
            <li>
              <button 
                className={currentPage === 'home' ? 'active' : ''}
                onClick={() => handlePageChange('home')}
              >
                🏠 首页
              </button>
            </li>
            <li>
              <button 
                className={currentPage === 'articles' ? 'active' : ''}
                onClick={() => handlePageChange('articles')}
              >
                📡 文章
              </button>
            </li>
            <li>
              <button 
                className={currentPage === 'projects' ? 'active' : ''}
                onClick={() => handlePageChange('projects')}
              >
                ⚡ 项目
              </button>
            </li>
          </ul>
        </nav>
      </header>
      <main>
        {renderContent()}
      </main>
    </div>
  );
}

export default App;
